/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers(['container', 'dot', 'white', 'dotOne', 'dotTwo', 'dotThree', 'dotFour']);

export default helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      width: 'var(--wrapper-size)',
      height: 'var(--wrapper-size)',
      margin: 'auto',
      animation: 'rotate var(--speed) linear infinite',

      sx: {
        '@keyframes rotate': {
          '0%': {transform: 'rotate(0)'},
          '10%': {width: 'var(--wrapper-size)', height: 'var(--wrapper-size)'},
          '66%': {width: 'var(--dot-size)', height: 'var(--dot-size)'},
          '100%': {transform: 'rotate(360deg)', width: 'var(--wrapper-size)', height: 'var(--wrapper-size)'},
        },

        '@keyframes dotsY': {
          '66%': {opacity: 0.1, width: 'var(--dot-size)'},
          '77%': {opacity: 1, width: 0},
        },

        '@keyframes dotsX': {
          '66%': {opacity: 0.1, height: 'var(--dot-size)'},
          '77%': {opacity: 1, height: 0},
        },

        '@keyframes flash': {
          '33%': {opacity: 0, borderRadius: '0%'},
          '55%': {opacity: '.6', borderRadius: '100%'},
          '66%': {opacity: 0},
        },
      },
    },
    dot: {
      borderRadius: '100%',
      height: 'var(--dot-size)',
      margin: 'auto',
      position: 'absolute',
      transition: 'all 1s ease',
      width: 'var(--dot-size)',
    },
    dotOne: {
      top: 0,
      bottom: 0,
      left: 0,
      background: '#FF4444',
      animation: 'dotsY var(--speed) linear infinite',
    },
    dotTwo: {
      left: 0,
      right: 0,
      top: 0,
      background: '#FFBB33',
      animation: 'dotsX var(--speed) linear infinite',
    },
    dotThree: {
      top: 0,
      bottom: 0,
      right: 0,
      background: '#99CC00',
      animation: 'dotsY var(--speed) linear infinite',
    },
    dotFour: {
      left: 0,
      right: 0,
      bottom: 0,
      background: '#33B5E5',
      animation: 'dotsX var(--speed) linear infinite',
    },
    white: {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      background: 'white',
      animation: 'flash var(--speed) linear infinite',
      opacity: 0,
    },
  },
  sizes: {
    sm: {
      container: {
        sx: {
          '--wrapper-size': '5.2em',
          '--dot-size': '2em',
          '--speed': '2.4s',
        },
      },
    },
    md: {
      container: {
        sx: {
          '--wrapper-size': '6.250em',
          '--dot-size': '2.4em',
          '--speed': '2.4s',
        },
      },
    },
    lg: {
      container: {
        sx: {
          '--wrapper-size': '9.5em',
          '--dot-size': '3.6em',
          '--speed': '2.4s',
        },
      },
    },
  },
  defaultProps: {
    size: 'md',
  },
});
